import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/ai-chatbot/PageContent.tsx");
